import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "../../locales/en.json"; 
import arTranslation from "../../locales/ar.json";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },
    resources: {
      en: {
        translation: enTranslation,
      },
      ar: {
        translation: arTranslation,
      },
    },
    fallbackLng: "ar",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
